export class LoginModel {
    username!: string;
    password!: string;
    country!: string;
    recaptchaToken!: string;
    token!: string;
    captchaToken!: string;
    userType!: string;
    storeId!: string;
    tenantId!: string;
  }
  